import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ExecucaoPlanoQualidadeService implements BaseServiceCadastros<ExecucaoPlanoQualidade> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/execucaoPlanoQualidade/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ExecucaoPlanoQualidade>((resolve, reject): void => {
            api
                .get(`/execucaoPlanoQualidade/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(execucaoPlanoQualidade: ExecucaoPlanoQualidade) {
        return new Promise<ExecucaoPlanoQualidade>((resolve, reject): void => {
            api
                .post(`/execucaoPlanoQualidade/incluir`, JSON.stringify(execucaoPlanoQualidade))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(execucaoPlanoQualidade: ExecucaoPlanoQualidade) {
        return new Promise<ExecucaoPlanoQualidade>((resolve, reject): void => {
            api
                .put(`/execucaoPlanoQualidade/editar`, JSON.stringify(execucaoPlanoQualidade))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/execucaoPlanoQualidade/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getStatus() {
        return [
            { label: 'Gerada', value: 'GERADA' },
            { label: 'Em Andamento', value: 'EM_ANDAMENTO' },
            { label: 'Reprovada', value: 'REPROVADA' },
            { label: 'Aprovada Parcial', value: 'APROVADA_PARCIAL' },
            { label: 'Aprovada', value: 'APROVADA' },
            { label: 'Cancelada', value: 'CANCELADA' }
        ]
    }

    getListaStatusFilter(){
        return [
            { label: 'Gerada', value: 'G' },
            { label: 'Em Andamento', value: 'E' },
            { label: 'Reprovada', value: 'R' },
            { label: 'Aprovada Parcial', value: 'P' },
            { label: 'Aprovada', value: 'A' },
            { label: 'Cancelada', value: 'C' }
        ]
    }

    getStatusLabel(status: string) {
        return this.getStatus().find(item => item.value === status)?.label || "";
    }

    getTiposResultado() {
        return [
            { label: 'Numérico', value: 'NUMERICO' },
            { label: 'Texto', value: 'TEXTO' },
            { label: 'Sim/Não', value: 'SIM_NAO' },
            { label: "Aprovado/Reprovado", value: "APROVADO_REPROVADO" }
        ]
    }

    getTipoResultadoLabel(tipoResultado: string) {
        return this.getTiposResultado().find(tipo => tipo.value === tipoResultado)?.label;
    }

    getItemStatus() {
        return [
            { label: 'Aprovado', value: 'APROVADO' },
            { label: 'Reprovado', value: 'REPROVADO' },
            { label: 'Não analisado', value: 'NAO_ANALISADO' },
        ]
    }

    getItemStatusLabel(status: string) {
        return this.getItemStatus().find(item => item.value === status)?.label || "";
    }

}

export default ExecucaoPlanoQualidadeService;